import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.find-index.js";
/**
 *  Art Create Wallet
 *    Scripts to control the scroll based transitions on the create
 *    a wallet page template.
 *
 *  Version
 *    1.0.0 - 2021/10/13
 */

var SELECTOR_CONTAINER = '[data-art-create-wallet]';
var SELECTOR_STEPS = '[data-wallet-steps]';
var SELECTOR_STEP = '[data-wallet-step]';
var SELECTOR_IMAGE = '[data-wallet-image]';
var CLASS_ACTIVE = 'is-active';
var ATTR_INDEX = 'data-index';
document.querySelectorAll(SELECTOR_CONTAINER).forEach(function (container) {
  // Elements
  var steps = container.querySelectorAll(SELECTOR_STEP);
  if (!steps) return;
  var stepsArray = Array.from(steps);
  var stepsContainer = container.querySelector(SELECTOR_STEPS);
  var phoneImages = container.querySelectorAll(SELECTOR_IMAGE);
  var phoneImagesArray = Array.from(phoneImages);
  var currentMiddle = document.documentElement.scrollTop + window.innerHeight / 2;

  // Event Listeners
  window.addEventListener('scroll', onScroll);
  onScroll();
  function onScroll() {
    var newMiddle = document.documentElement.scrollTop + window.innerHeight / 2;
    if (currentMiddle === newMiddle) return;
    currentMiddle = newMiddle;

    //Before first step
    if (currentMiddle < stepsContainer.offsetTop) {
      return setActiveStep(0);
    }
    //After last step
    if (currentMiddle > stepsContainer.offsetTop + stepsContainer.offsetHeight) {
      return setActiveStep(stepsArray.length - 1);
    }

    //Inside steps, find the active one
    var activeStepIndex = stepsArray.findIndex(function (step) {
      if (currentMiddle > step.offsetTop && currentMiddle <= step.offsetTop + step.offsetHeight) {
        return true;
      }
    });
    if (activeStepIndex != -1) setActiveStep(activeStepIndex);
  }
  function setActiveStep(index) {
    stepsArray.forEach(function (step, i) {
      if (i === index) {
        step.classList.add(CLASS_ACTIVE);
      } else {
        step.classList.remove(CLASS_ACTIVE);
      }
    });
    phoneImagesArray.forEach(function (image, i) {
      if (i === index) {
        image.classList.add(CLASS_ACTIVE);
      } else {
        image.classList.remove(CLASS_ACTIVE);
      }
    });
  }
});